export default __webpack_public_path__ + "static/media/IconDesc_Plastic.256.5bbda74f.png";